import React from 'react';
import Delete from '../delete';
import AddDialog from './add';
import EditDialog from './edit';

export default function ModalsView() {
	return (
		<div>
			<AddDialog />
			<EditDialog />
			<Delete />
		</div>
	);
}
